import { render, staticRenderFns } from "./holderInfo.vue?vue&type=template&id=3d5651cf&scoped=true&"
import script from "./holderInfo.vue?vue&type=script&lang=js&"
export * from "./holderInfo.vue?vue&type=script&lang=js&"
import style0 from "./holderInfo.vue?vue&type=style&index=0&id=3d5651cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5651cf",
  null
  
)

export default component.exports